import type { KitTemplate, KitTemplateBackground } from '../shared/types';

export function kitTemplateBackgroundLabel(background: KitTemplateBackground): string {
  switch (background.kind) {
    case 'color':
      return background.color;
    case 'designed':
      return background.label;
    case 'image':
      return `${background.width} x ${background.height} image`;
  }
  return 'Unknown background';
}

export function kitTemplateStatusLabel(template: KitTemplate): string {
  return template.isDefault ? `${template.status} default` : template.status;
}

export function kitTemplateCardScaleLabel(template: KitTemplate): string {
  return template.cardScale === undefined ? 'Default' : `${Math.round(template.cardScale * 100)}%`;
}

export function kitTemplateBackgroundPreviewUrl(template: KitTemplate): string | undefined {
  return template.background.kind === 'image' ? template.background.previewUrl : undefined;
}

export function kitTemplateBackgroundColor(template: KitTemplate): string {
  switch (template.background.kind) {
    case 'color':
      return template.background.color;
    case 'designed':
      return template.background.color;
    case 'image':
      return '#111111';
  }
  return '#111111';
}
